<template>
  <!-- Usually there is a <router-view> or dynamic component here rendering the template -->
  <router-view></router-view> 
</template>

<script>
import axios from "axios";

export default {
  computed: {
    userId() {
      return this.$store.state.auth.user._id;
    }
  },
  async created() {
    const organizationSlug = this.$route.params.organizationSlug;
    if(organizationSlug === 'gala') {
      this.$store.commit("organization/SET_ORGANIZATION_SLUG", "gala");
    } else {
      this.$store.commit("organization/SET_ORGANIZATION_SLUG", "default");
    }
    
    this.$store.dispatch("editor/toggleRightBar", false);
    this.$store.dispatch("editor/toggleRightBarPrompt", false);
    this.$store.dispatch("editor/togglePreviewMode", true);

    // NEW: FETCH OFFERS FROM PYTHON SQLITE FOR THE PREVIEW
    if (this.userId) {
      try {
        const res = await axios.get(`https://parser.ai.getboarded.com/api/offers/${this.userId}`);
        if (res.data.status === 'success') {
          this.$store.commit("editor/SET_OFFERS", res.data.data);
        }
      } catch (err) {
        console.error("Failed to load offers for preview:", err);
      }
    }
  },
};
</script>